import React from 'react';
import * as PropTypes from "prop-types";

export const FEATURE_ENABLED_PROPERTIES = ["hasKv", "hasQt", "hasBv", "hasBvQt"]; // old support

const propsObject = {};
FEATURE_ENABLED_PROPERTIES.forEach(property => {
  propsObject[property] = PropTypes.bool
})

export const featureInterface = {
  featureDefinitionId: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  price: PropTypes.number,
  cost: PropTypes.number,
  fabricatorCost: PropTypes.number,
  sku: PropTypes.string,
  enabled: PropTypes.bool,
  selected: PropTypes.bool,
  uofM: PropTypes.string,
  unlocked: PropTypes.bool,
  ...propsObject,
  toolSettings: PropTypes.array, // new logic with fireplace and other tools
  // [{fabricatorFeature_Id:58249298, tool:"bathroom", created:"2022-05-09T20:15:59", createdBy_id:9,
  // modified:"2022-05-09T20:15:59", modifiedBy_id:9, enableVisualizer:false, enableQuotingTool:false, fabricatorFeature:null}]
};
